import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled, { css } from 'styled-components';
import { Button } from '../button/index.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
const CarouselWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__CarouselWrapper",
  componentId: "sc-76u1c9-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n\n  .carousel__viewport {\n    overflow: hidden;\n    width: 100%;\n  }\n\n  .carousel__container {\n    display: flex;\n    margin-left: ", ";\n    user-select: none;\n  }\n\n  .carousel__slide {\n    position: relative;\n    flex: ", ";\n    padding-left: ", ";\n\n    ", " {\n      ", "\n    }\n\n    ", " {\n      ", "\n    }\n\n    > img {\n      display: block;\n      height: 100%;\n      width: 100%;\n      object-fit: contain;\n      border-radius: ", ";\n    }\n  }\n"])), _ref => {
  let {
    theme
  } = _ref;
  return "-".concat(theme.spacing.baseSpacing);
}, _ref2 => {
  let {
    visibleSlides
  } = _ref2;
  return "0 0 ".concat(100 / visibleSlides, "%");
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.spacing.baseSpacing;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.mediaQueries.sm;
}, _ref5 => {
  let {
    visibleSlidesTablet
  } = _ref5;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          flex-basis: ", "%;\n        "])), 100 / visibleSlidesTablet);
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.mediaQueries.md;
}, _ref7 => {
  let {
    visibleSlidesDesktop
  } = _ref7;
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          flex-basis: ", "%;\n        "])), 100 / visibleSlidesDesktop);
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.radii.default;
});
const CarouselButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "styles__CarouselButton",
  componentId: "sc-76u1c9-1"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  padding: ", ";\n  border-radius: 50%;\n  color: ", ";\n  background-color: ", ";\n  box-shadow: ", ";\n\n  &:not(:disabled) {\n    &:hover,\n    &:focus,\n    &:active {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n\n  &:disabled {\n    opacity: 0;\n    cursor: auto;\n  }\n"])), _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.spacing.baseSpacing;
}, _ref10 => {
  let {
    theme
  } = _ref10;
  return theme.colors.primary.main;
}, _ref11 => {
  let {
    theme
  } = _ref11;
  return theme.colors.background;
}, _ref12 => {
  let {
    theme
  } = _ref12;
  return theme.boxShadows.default;
}, _ref13 => {
  let {
    theme
  } = _ref13;
  return theme.colors.primary.contrastText;
}, _ref14 => {
  let {
    theme
  } = _ref14;
  return theme.colors.primary.light;
});
const CarouselButtonNext = /*#__PURE__*/styled(CarouselButton).withConfig({
  displayName: "styles__CarouselButtonNext",
  componentId: "sc-76u1c9-2"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  right: 0;\n  transform: ", ";\n\n  [dir='rtl'] & {\n    right: auto;\n    left: 0;\n    transform: ", ";\n  }\n"])), _ref15 => {
  let {
    theme
  } = _ref15;
  return "translate(".concat(theme.spacing.baseSpacing, ", -50%)");
}, _ref16 => {
  let {
    theme
  } = _ref16;
  return "translate(-".concat(theme.spacing.baseSpacing, ", -50%)");
});
const CarouselButtonPrev = /*#__PURE__*/styled(CarouselButton).withConfig({
  displayName: "styles__CarouselButtonPrev",
  componentId: "sc-76u1c9-3"
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  left: 0;\n  transform: ", ";\n\n  [dir='rtl'] & {\n    left: auto;\n    right: 0;\n    transform: ", ";\n  }\n"])), _ref17 => {
  let {
    theme
  } = _ref17;
  return "translate(-".concat(theme.spacing.baseSpacing, ", -50%)");
}, _ref18 => {
  let {
    theme
  } = _ref18;
  return "translate(".concat(theme.spacing.baseSpacing, ", -50%)");
});
const CarouselDots = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__CarouselDots",
  componentId: "sc-76u1c9-4"
})(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  gap: ", ";\n  padding-top: ", ";\n"])), _ref19 => {
  let {
    theme
  } = _ref19;
  return theme.spacing.halfSpacing;
}, _ref20 => {
  let {
    theme
  } = _ref20;
  return theme.spacing.baseSpacing;
});
const CarouselDot = /*#__PURE__*/styled(Button).withConfig({
  displayName: "styles__CarouselDot",
  componentId: "sc-76u1c9-5"
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  padding: 0;\n  box-shadow: none;\n  background-color: ", ";\n"])), _ref21 => {
  let {
    theme
  } = _ref21;
  return theme.spacing.doubleSpacing;
}, _ref22 => {
  let {
    theme
  } = _ref22;
  return theme.spacing.halfSpacing;
}, _ref23 => {
  let {
    theme,
    selected
  } = _ref23;
  return selected ? theme.colors.primary.light : theme.colors.surface;
});

export { CarouselButtonNext, CarouselButtonPrev, CarouselDot, CarouselDots, CarouselWrapper };
